<template>
  <div class="electron-true">
    <div class="terminal-content">
        <div id="terminalGameMenu" class="terminal-left terminal-block" style="display: none">
            <div class="header-bar">
                    Games
            </div>
            <ul id="terminal-sidebar">
            </ul>
        </div>
        
        <div class="terminal-tabs-wrapper">
          <div class="terminal-tabs terminal-full-width" id="terminal-tab-menu">
            <ul id="lbTabMenu">
                <li :class="selectedTab == 'betting'  && !extraBets ? 'selected' : ''"><a href="#" data-tab="betting" data-langName="betting" @click="select('betting')">Betting</a></li>
                <!-- <li :class="selectedTab == 'statistics' ? 'selected' : ''"><a href="#" data-tab="statistics" data-langName="statistics" @click="select('statistics')">statistics</a></li> -->
                <li :class="extraBets ? 'extrasSelected' : ''"><a href="#" data-tab="extra-bets"  @click="select('extra-bets')" data-langName="extraBets">Dodatno Klađenje</a></li>
                <li :class="selectedTab == 'results' && !extraBets ? 'selected' : ''"><a href="#" data-tab="results" data-langName="results" @click="select('results')">Results</a></li>         
            </ul>
        </div>
        <div class="terminal-content-tabs  terminal-full-width">
                <Betting v-show="selectedTab == 'betting'" :gameTimer="gameTimer" :currentIdToday="currentIdToday" 
                  :resultTimer="resultTimer" :gameStatus="gameStatus" :gameTimerMax="gameTimerMax" :gameTimerResultMax="gameTimerResultMax" />
                <Results v-if="selectedTab == 'results'" :gameTimer="gameTimer" :currentIdToday="currentIdToday"
                 :resultTimer="resultTimer" :gameStatus="gameStatus" :gameTimerMax="gameTimerMax" :gameTimerResultMax="gameTimerResultMax" />
                <Statistics v-show="selectedTab == 'statistics'" />
        </div>
        </div>
        <div class="terminal-bet-bar">
            <BetBar/>
        </div>
        
        <div class="clearfix" style="height:30px;"></div>
    </div>
         <ConfirmBuyModal />
         <NumpadModal v-if="showNumpad" />
        <div class="hidden-elements" style="display:none">

            <div class="game-holder video">
                <div class="game-holder-bar" style="display: block;">Lucky Balls <span id="jackpotDisplay"></span></div>
                <div class="video-holder" style="position:relative;">

                </div>
            </div>

            <div class="modal fade" id="buyTicketModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <h5 class="modal-title" data-langName="purchased_a_ticket"></h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="loadingModal" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <div class="modal-loader"></div>
                            <div class="modal-loader-percentage"><span id="modalLoaderPercentage">100</span>%</div>
                            <h5 class="modal-title" id="loaderWaitText"></h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="buyTicketError">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <h5 class="modal-title" id="modalErrorMessage" data-langName="chose_some_bets"></h5>
                            <button style="float: right;" type="button" class="btn btn-secondary betting-btn"
                            data-dismiss="modal">Ok
                        </button>
                    </div>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<style lang="scss">
  
</style>

<script>
import $eventBus from '../eventBus';
import Betting from '../components/lucky-balls/Betting.vue'; 
import BetBar from '../components/lucky-balls/BetBar.vue';
import NumpadModal from '../components/general/modals/NumpadModal.vue';
import ConfirmBuyModal from '../components/general/modals/ConfirmBuyModal.vue';
import Statistics from '../components/lucky-balls/Statistics.vue';
import Results from '../components/lucky-balls/Results.vue';
import {initLang, translate} from '../assets/common/lang';
import { mapGetters } from "vuex";

export default {
  name: 'LuckyBalls',
  components: {
      Betting,
      BetBar,
      NumpadModal,
      ConfirmBuyModal,
      Statistics,
      Results
  },
  data() {
    return {
        showNumpad: false,
        selectedTab: 'betting',
        extraBets: false,
        nextTimer: 0,
        gameInterval: undefined,
        resultGameInterval: undefined,
        resultTimer: null,
        gameTimer: null,
        currentIdToday: null,
        gameStatus: null,
        alreadyInitiated: false,
        gameTimerMax: null,
        gameTimerResultMax: null,
        gameStatusRetryInterval: null,
        gameStatusRetryCounter: 0
    }
  },
  computed: {
    ...mapGetters(["getGameStatus"])
  },
  watch: {
    getGameStatus() {
      if (this.getGameStatus) {
        clearInterval(this.gameInterval);
        clearInterval(this.resultGameInterval);
        clearInterval(this.gameStatusRetryInterval);
        this.gameInterval = undefined;
        this.resultGameInterval = undefined;
        this.gameStatusRetryInterval = undefined;
        this.initiateGameStatus();
        // if (!this.alreadyInitiated) {
        //   this.initiateGameStatus();
        // }
        // this.handleGameResultRender();
      } else {
        this.retryGameStatus();
      }
    }
  },
  methods: {
		openNumpad() {
      this.showNumpad = true;
    },
    closeNumpad() {
      this.showNumpad = false;
    },
    getGameTimerMax() {
      const gameTimeStart = this.getGameStatus.GameTimeStart;
      const gameTimeEnd = this.getGameStatus.GameTimeEnd;

      // Convert the timestamps to Date objects
      const startDate = new Date(gameTimeStart);
      const endDate = new Date(gameTimeEnd);

      // Calculate the difference in milliseconds
      const timeDiffMilliseconds = endDate - startDate;

      // Convert milliseconds to seconds
      const timeDiffSeconds = timeDiffMilliseconds / 1000;

      return timeDiffSeconds;
    },
    getResultsTimerMax(){
      const gameTimeStart = this.getGameStatus.GameTimeStart;
      const gameTimeEnd = this.getGameStatus.GameTimeEnd;

      // Convert the timestamps to Date objects
      const startDate = new Date(gameTimeStart);
      const endDate = new Date(gameTimeEnd);

      // Calculate the difference in milliseconds
      const timeDiffMilliseconds = endDate - startDate;

      // Convert milliseconds to seconds
      const timeDiffSeconds = timeDiffMilliseconds / 1000;

      return timeDiffSeconds;
    },
    retryGameStatus() {
      clearInterval(this.gameStatusRetryInterval);
      if (!this.getGameStatus || !Object.keys(this.getGameStatus).length) {
        this.gameStatusRetryCounter = 0; // Reset the retry counter
        this.gameStatusRetryInterval = setInterval(() => {
          if (this.gameStatusRetryCounter >= 500) {
            clearInterval(this.gameStatusRetryInterval);
          }
          this.$store.dispatch("callGameStatus");
          this.gameStatusRetryCounter++;
        }, 1500);
      }
    },

    setUpResultTimer() {
      clearInterval(this.gameInterval);
      this.gameInterval = undefined;

      // Check for existence of getGameStatus before accessing properties
      this.resultTimer = this.getGameStatus ? Number(this.getGameStatus.GameTimerResult) : 0;

      this.resultGameInterval = setInterval(() => {
        if (this.resultTimer <= 0) {
          clearInterval(this.resultGameInterval);
          this.resultGameInterval = undefined;
          this.$store.dispatch("setGameStatus", {});
          this.$store.dispatch("callGameStatus");
          this.setUpTimer();
        }
        this.currentIdToday = this.getGameStatus ? this.getGameStatus.ID_Today : null;
        this.gameStatus = this.getGameStatus ? this.getGameStatus.GameStatus : null;
        this.gameTimerMax = this.getGameStatus && this.gameStatus == 0 ? this.getGameTimerMax() : null;
        this.gameTimerResultMax = this.getGameStatus && this.gameStatus == 1 ? this.getResultsTimerMax() : null;
        this.resultTimer--;
      }, 1000);
    },

    setUpTimer() {
      clearInterval(this.resultGameInterval);
      this.resultGameInterval = undefined;
      // Check for existence of getGameStatus before accessing properties
      this.gameTimer = this.getGameStatus ? Number(this.getGameStatus.GameTimer) : 0;
      this.gameInterval = setInterval(() => {
        if (this.gameTimer <= 0) {
          clearInterval(this.gameInterval);
          this.gameInterval = undefined;
					this.$store.dispatch('callGameResults');
          this.$store.dispatch("setGameStatus", {});
          this.$store.dispatch("callGameStatus");
          this.setUpResultTimer();
        }
        this.gameStatus = this.getGameStatus ? this.getGameStatus.GameStatus : null;
        this.currentIdToday = this.getGameStatus ? this.getGameStatus.ID_Today : null;
        this.gameTimerMax = this.getGameStatus && this.gameStatus == 0 ? this.getGameTimerMax() : null;
        this.gameTimerResultMax = this.getGameStatus && this.gameStatus == 1 ? this.getResultsTimerMax() : null;
        this.gameTimer--;
      }, 1000);
    },

    initiateGameStatus() {
      if (this.getGameStatus) {
        if (Number(this.getGameStatus.GameTimer) <= 0) {
          this.setUpResultTimer();
        } else {
          this.setUpTimer();
        }
        this.alreadyInitiated = true;
      }
    },
    select(tab) {
      if (tab == 'extra-bets') {
        this.selectedTab = 'betting';
        this.$nextTick(() => {
            this.extraBets = true;
            $eventBus.$emit('setExtraBalls', true);
        });
      } else {
        $eventBus.$emit('setExtraBalls', false);
        this.extraBets = false;
        this.selectedTab = tab;
      }
    }
  },
  mounted() {
     $eventBus.$on('openNumpad', () => {
			// console.log('TEST OPEN PAD ')
      this.openNumpad();
    });
    $eventBus.$on('closeNumpad', () => {
      this.closeNumpad();
    });
    $eventBus.$on('drawResultsPrintedSuccess', () => {
        if (this.selectedTab === 'results') {
            this.selectedTab = 'betting';
        }
        this.$bvToast.toast(translate('draw_results_printed'), {
            title: translate('notification'),
            variant: "success b-toaster-top-center",
            autoHideDelay: 3000,
            toaster: 'b-toaster-top-center',
        });
    });
    $eventBus.$on('luckBallsChangeTab', tab => {
        this.selectedTab = tab;
    });
    this.$store.dispatch("callGameStatus");
  },
  updated() {
      initLang();
  },
  destroyed() {
    clearInterval(this.gameInterval);
    clearInterval(this.resultGameInterval);
    clearInterval(this.gameStatusRetryInterval);
    this.gameInterval = undefined;
    this.resultGameInterval = undefined;
    this.gameStatusRetryInterval = undefined;
  },
   beforeDestroy() {
    $eventBus.$off(`drawResultsPrintedSuccess`);
    $eventBus.$off(`openNumpad`);
    $eventBus.$off(`closeNumpad`);
    $eventBus.$off(`luckBallsChangeTab`);
   }
}
</script>
